import React from 'react';
import { CURRENT_MEMBER, TIMELINE_END, TIMELINE_SPAN, TIMELINE_START, overlapWith, parseYears } from '../../data/community';
import type { Member } from '../../data/community';
interface YearsRibbonProps {
  member: Member;
  /** Draw the signed-in member's span underneath for comparison. */
  compare?: boolean;
}
const TICKS = [1976, 1986, 1996, 2006, 2016, 2026];
function span(years: string) {
  const {
    start,
    end
  } = parseYears(years);
  return {
    left: `${(start - TIMELINE_START) / TIMELINE_SPAN * 100}%`,
    width: `${Math.max((end - start) / TIMELINE_SPAN * 100, 1.5)}%`
  };
}

/** Their span across fifty years — the one fact this product is organized by. */
export function YearsRibbon({
  member,
  compare = false
}: YearsRibbonProps) {
  const overlap = compare ? overlapWith(member, CURRENT_MEMBER) : null;
  return <div className="flex flex-col gap-1.5" data-id="element-353" data-mp="33ydv1uyhzdpl">
      <div className="relative h-6" data-id="element-354" data-mp="2z0uh6w5pp2y6">
        <span aria-hidden="true" className="absolute inset-x-0 top-1/2 h-px -translate-y-1/2 bg-rule" data-id="element-355" data-mp="2yzsvlxr2ky27" />
        {overlap ? <span aria-hidden="true" className="absolute top-0 h-full rounded-sm bg-primary-soft" style={span(`${overlap.start}–${overlap.end}`)} data-id="element-356" data-mp="nv5ydhf2p7o4" /> : null}
        <span className="absolute top-1/2 h-2.5 -translate-y-1/2 rounded-pill bg-primary" style={span(member.years)} data-id="element-357" data-mp="et6gkmw8hzk4" />
        <span className="sr-only" data-id="element-358" data-mp="3qp14ovpq3d">{member.years}</span>
      </div>

      {compare ? <div className="relative h-4" data-id="element-359" data-mp="4xctwaoswpom">
          <span className="absolute top-1/2 h-1.5 -translate-y-1/2 rounded-pill bg-ink-subtle" style={span(CURRENT_MEMBER.years)} data-id="element-360" data-mp="3n9ren8nbv88g" />
          <span className="sr-only" data-id="element-361" data-mp="3rbmgce967nmr">Your years, {CURRENT_MEMBER.years}</span>
        </div> : null}

      <div className="relative h-4" data-id="element-362" data-mp="3ddohkh7c1zsd">
        {TICKS.map(tick => <span key={tick} className="absolute -translate-x-1/2 text-eyebrow-caption font-medium text-ink-muted" style={{
        left: `${(tick - TIMELINE_START) / TIMELINE_SPAN * 100}%`
      }} data-id="element-363" data-mp="3i9d8xx978adl">
            {tick === TIMELINE_END ? 'now' : tick}
          </span>)}
      </div>
    </div>;
}